export default __webpack_public_path__ + "static/media/dog1.png.3b145bff.png";